export const FEATURE_GL_P4P_SNAPSHOT = 1;
export const FEATURE_PDF_NEW_COMPANY_MENU = 2;
export const FEATURE_PDF_NEW_INVESTOR_MENU = 3;
export const FEATURE_PDF_NEW_REMAINING_MENU = 4;
export const FEATURE_ECM_SNAPSHOT = 5;
export const FEATURE_SHARES_VOTED_DATE_UPDATES = 6;
export const FEATURE_VOTING_DISCLOSURE = 6;
export const FEATURE_P4P_SNAPSHOT = 7;
export const FEATURE_TSR_CALCULATOR = 8;
export const FEATURE_DISCLOSURE_SEARCH = 9;
export const FEATURE_INTERLOCKS_AND_CONNECTIONS = 10;
export const FEATURE_PEER_COMPOSER = 11;
export const FEATURE_VOTING_DIFF_TOOL = 12;
export const FEATURE_COMPENSATION_BENCHMARKING = 14;

export const FEATURE_ACCESS_HIDDEN = 0;
export const FEATURE_ACCESS_ENABLED = 1;
export const FEATURE_ACCESS_DISABLED = 2;
export const FEATURE_ACCESS_LIMITED = 3;

export default {
  FEATURE_GL_P4P_SNAPSHOT,
  FEATURE_PDF_NEW_COMPANY_MENU,
  FEATURE_PDF_NEW_INVESTOR_MENU,
  FEATURE_PDF_NEW_REMAINING_MENU,
  FEATURE_ECM_SNAPSHOT,
  FEATURE_SHARES_VOTED_DATE_UPDATES,
  FEATURE_TSR_CALCULATOR,
  FEATURE_VOTING_DISCLOSURE,
  FEATURE_P4P_SNAPSHOT,
  FEATURE_INTERLOCKS_AND_CONNECTIONS,
  FEATURE_DISCLOSURE_SEARCH,
  FEATURE_PEER_COMPOSER,
  FEATURE_VOTING_DIFF_TOOL,
  FEATURE_COMPENSATION_BENCHMARKING,
  FEATURE_ACCESS_HIDDEN,
  FEATURE_ACCESS_ENABLED,
  FEATURE_ACCESS_DISABLED,
  FEATURE_ACCESS_LIMITED,
};
